var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsoleacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.143,
    height: 33.14,
    viewBox: "0 0 33.143 33.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651",
    transform: "translate(18126.172 -14401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M403.81,323.749a.593.593,0,0,0-.328.1l-1.775,1.184a.592.592,0,0,0,.656.985l.771-.514a8.862,8.862,0,0,1-8.792,7.715.592.592,0,1,0,0,1.184,10.071,10.071,0,0,0,10-8.993l.913.609h0a.592.592,0,0,0,.657-.985l-1.775-1.184a.591.591,0,0,0-.328-.1Z",
    transform: "translate(-18500.393 14096.781)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M358.285,35a8.285,8.285,0,1,0,8.285,8.285.592.592,0,0,0-.964-.46,4.871,4.871,0,0,1-6.861-6.861.592.592,0,0,0-.46-.964Zm-1.1,1.405a5.888,5.888,0,0,0,7.98,7.98,7,7,0,0,1-6.88,6,7.093,7.093,0,0,1-7.1-7.1,7,7,0,0,1,6-6.88Z",
    transform: "translate(-18459.6 14366.004)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M223.78,78.75a10.022,10.022,0,0,0-5.053,1.359.592.592,0,0,0,.6,1.023,8.828,8.828,0,0,1,4.458-1.2.592.592,0,1,0,0-1.184Z",
    transform: "translate(-18336.932 14325.209)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M126.118,148.436a.593.593,0,0,0-.475.294,10.005,10.005,0,0,0-1.3,3.989l-.917-.611h0a.592.592,0,1,0-.657.985l1.775,1.184a.591.591,0,0,0,.657,0l1.775-1.184a.592.592,0,1,0-.657-.985l-.78.52a8.814,8.814,0,0,1,1.123-3.3.593.593,0,0,0-.548-.889Z",
    transform: "translate(-18247.496 14260.238)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    d: "M114.469,245a.592.592,0,0,0-.592.592V247.4a7.066,7.066,0,0,0-3.989,1.654l-1.278-1.278a.591.591,0,0,0-.4-.174h-.05a.591.591,0,0,0-.386,1.009l1.278,1.278a7.069,7.069,0,0,0-1.654,3.989h-1.805a.592.592,0,1,0,0,1.184H107.4a7.065,7.065,0,0,0,1.654,3.989l-1.278,1.278a.592.592,0,0,0,.837.837l1.278-1.278a7.069,7.069,0,0,0,3.989,1.654v1.805a.592.592,0,1,0,1.184,0V261.54a7.066,7.066,0,0,0,3.989-1.654l1.278,1.278a.592.592,0,1,0,.837-.837l-1.278-1.278a7.069,7.069,0,0,0,1.654-3.989h1.805a.592.592,0,1,0,0-1.184H121.54a7.065,7.065,0,0,0-1.654-3.989l1.278-1.278h0a.592.592,0,0,0-.4-1.01h-.051a.592.592,0,0,0-.385.172l-1.278,1.278a7.069,7.069,0,0,0-3.989-1.654v-1.805a.592.592,0,0,0-.592-.592Zm0,3.551a5.918,5.918,0,1,1-5.918,5.918A5.909,5.909,0,0,1,114.469,248.551Z",
    transform: "translate(-18231.172 14170.203)",
    fill: "#434343"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsoleacion);
export default __webpack_public_path__ + "static/media/asoleacion.b18023cda50811d5ec39b5757eddc956.svg";
export { ForwardRef as ReactComponent };